import { formatPrice } from '../../../shared/helpers';
export const getSalesTax = (selectedTier, salestax) => {
    if (selectedTier.recurringPrice !== undefined && selectedTier.recurringPrice === 0) {
        return '$0.00';
    }
    return (typeof salestax === 'number') ? formatPrice(salestax) : 'TBD';
};
